import { Injectable, inject } from '@angular/core';

import { ToastrQueueService } from '@frontend/vanilla/core';

import { GeoCoordinatorActivatorService } from './activator.service';
import { GeoCoordinatorClientConfig } from './client-config';

@Injectable({
    providedIn: 'root',
})
export class GeoCoordinationOobeeIntimationService {
    private readonly geoCoordinatorConfig = inject(GeoCoordinatorClientConfig);
    private readonly geoCoordinatorActivatorService = inject(GeoCoordinatorActivatorService);

    private readonly toasterService = inject(ToastrQueueService);
    constructor() {}

    display(): void {
        this.geoCoordinatorConfig.whenReady.subscribe(async () => {
            if (await this.geoCoordinatorActivatorService.isActive()) {
                if (this.geoCoordinatorConfig.additionalSettings.oobeeIntimation?.enabled ?? false) {
                    this.toastIt((this.geoCoordinatorConfig.additionalSettings.oobeeIntimation?.toasterId ?? '').trim());
                }
            }
        });
    }

    private toastIt(toasterId: string) {
        if (toasterId) {
            this.toasterService.add(toasterId);
        }
    }
}
